import Icon from '@/components/UI/Icon/Icon';
import type { FC } from 'react';
import styles from './SessionInputsPanel.module.scss';

/**
 * Left panel of the agent session page: the read-only configuration that seeded the run. Fixed width
 * and independently scrollable; plain DOM, outside the canvas. Body is empty for now — the inputs are
 * populated once the session inputs source is wired.
 */
const SessionInputsPanel: FC = () => (
  <aside className={styles.panel} data-test-component="SessionInputsPanel">
    <div className={styles.header}>
      <Icon icon="cog" className={styles.headerIcon} />
      Configuration
    </div>
  </aside>
);

export default SessionInputsPanel;
